import { styled } from '../Stitches';

export const Padding = styled('div', {
  variants: {
    size: {
      xs: {
        padding: '$2',
      },
      sm: {
        padding: '$3',
      },
      md: {
        padding: '$4',
      },
      lg: {
        padding: '$6',
      },
      xl: {
        padding: '$7',
      },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});

export const PaddingInline = styled('div', {
  variants: {
    size: {
      xs: {
        paddingInline: '$2',
      },
      sm: {
        paddingInline: '$3',
      },
      md: {
        paddingInline: '$4',
      },
      lg: {
        paddingInline: '$6',
      },
      xl: {
        paddingInline: '$7',
      },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});

export const PaddingBlock = styled('div', {
  variants: {
    size: {
      xs: {
        paddingBlock: '$2',
      },
      sm: {
        paddingBlock: '$3',
      },
      md: {
        paddingBlock: '$4',
      },
      lg: {
        paddingBlock: '$6',
      },
      xl: {
        paddingBlock: '$7',
      },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});
